// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  portalId: __t.string().name("portal_id"),
  mapId: __t.string().name("map_id"),
  x: __t.i32(),
  y: __t.i32(),
  destMapId: __t.string().name("dest_map_id"),
  destX: __t.i32().name("dest_x"),
  destY: __t.i32().name("dest_y"),
  destMapKind: __t.string().name("dest_map_kind"),
});
